const MtrArrowDownOutline={
    "name": "mtr-arrow-down",
    "theme": "outline",
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M5.71929 7.30529C5.62704 7.20978 5.5167 7.1336 5.39469 7.08119C5.27269 7.02878 5.14147 7.00119 5.00869 7.00004C4.87591 6.99888 4.74423 7.02419 4.62133 7.07447C4.49844 7.12475 4.38679 7.199 4.29289 7.29289C4.199 7.38679 4.12475 7.49844 4.07447 7.62134C4.02419 7.74423 3.99888 7.87591 4.00004 8.00869C4.00119 8.14147 4.02878 8.27269 4.08119 8.39469C4.1336 8.5167 4.20978 8.62704 4.30529 8.71929L12.0123 16.4263L19.7193 8.71929C19.9014 8.53069 20.0022 8.27808 20 8.01589C19.9977 7.75369 19.8925 7.50288 19.7071 7.31747C19.5217 7.13206 19.2709 7.02689 19.0087 7.02461C18.7465 7.02234 18.4939 7.12313 18.3053 7.30529L12.0123 13.5983L5.71929 7.30529Z",
                    "fill": "currentColor"
                }
            }
        ]
    }
};
export default MtrArrowDownOutline;